import { connect } from 'react-redux'
import GroupsHead from './groups-head'
import { openAddGroupDialog } from '../dialogs/add-group/add-group.actions'
import { isShowingSelected } from '../groups-component-redux/groups-component-redux.selectors'
import { unsetShowSelectedGroups } from '../groups-component-redux/groups-component-redux.actions'

const mapStateToProps = state => ({
  showingSelected: isShowingSelected(state)
})

const mapDispatchToProps = dispatch => ({
  onAddGroup: () => dispatch(openAddGroupDialog()),
  showAll: () => dispatch(unsetShowSelectedGroups())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupsHead)
